import { Icon, icon } from "@hm/fundamental"

interface RangeToggleProps {
	isRangeMode: boolean
	onToggle: () => void
	label: string
	"data-cy": string
}

export const RangeToggle: React.FC<RangeToggleProps> = ({
	isRangeMode,
	onToggle,
	label,
	"data-cy": dataCy,
}) => {
	return (
		<label
			className="flex items-center gap-2 mt-4 cursor-pointer select-none"
			data-cy={`${dataCy}-range-toggle`}
		>
			<Icon
				path={
					isRangeMode
						? icon.mdiCheckboxMarked
						: icon.mdiCheckboxBlankOutline
				}
				size="regular"
				className={
					isRangeMode ? "text-primary" : "text-border_highlight_10"
				}
			/>
			<input
				type="checkbox"
				checked={isRangeMode}
				onChange={onToggle}
				className="sr-only"
				aria-label={label}
			/>
			<span className="text-sm text-foreground">{label}</span>
		</label>
	)
}
